<section class="stat-card" [attr.aria-labelledby]="titleId">
  <to-section-title [headingId]="titleId" [title]="titleKey() | translate" [subtitle]="subtitleKey() | translate" />

  <div class="stat-card__stats" role="group" aria-live="polite">
    @for (stat of stats(); track stat.labelKey) {
      <div
        class="stat-card__stat"
        role="group"
        [attr.aria-label]="
          statAriaKey()
            ? (statAriaKey()! | translate: { label: stat.labelKey | translate, value: stat.value })
            : (stat.labelKey | translate) + ': ' + stat.value
        "
      >
        <div class="stat-card__stat-label" aria-hidden="true">{{ stat.labelKey | translate }}</div>
        <div class="stat-card__stat-value" [style.color]="'var(' + stat.colorVar + ')'" aria-hidden="true">
          {{ stat.value }}
        </div>
      </div>
    }
  </div>

  @if (sectionLabelKey()) {
    <h3 class="stat-card__section-label">{{ sectionLabelKey()! | translate }}</h3>
  }

  <ng-content></ng-content>
</section>
